import React, {useEffect, useRef, useState} from "react";
import Form from "react-bootstrap/Form";
import {ethers} from "ethers";
import {Button, Modal, Toast} from "react-bootstrap";
import {
    arbitrumCurrent,
    marketContractAbi,
    marketContractAddress, tokenContractAbi, tokenContractAddress,
    switchToArbitrum
} from "../../helpers/contracts";
import {Grid} from "react-loader-spinner";

function Marketing(props) {
    const [toastText, setToastText] = useState('')
    const [toastErrorShow, setToastErrorShow] = useState(false)
    const [toastCompleteShow, setToastCompleteShow] = useState(false)
    const [showWwModal, setWwModal] = useState(false)
    const [myReferralRate, setMyReferralRate] = useState(0)
    const [priceOfChange, setPriceOfChange] = useState(0)
    const [showNetSendModal, setShowNetSendModal] = useState(false)
    const [targetErc, setTargetErc] = useState('')
    const [targetAmount, setTargetAmount] = useState(0)
    const [maxValue, setMaxValue] = useState(0)
    const [amountToSend, setAmountToSend] = useState(0)
    const inputRef = useRef(null);
    const inputAmountRef = useRef(null);
    const [preloader, setPreloader] = useState({display: 'none'})

    const handleRateChange = (e) => {
        const input = e.target;
        const value = input.value;

        // Разрешаем цифры, точку и запятую (для дробных чисел)
        const cleanValue = value.replace(/[^0-9.,]/g, '');

        // Заменяем запятую на точку для единообразия
        const normalizedValue = cleanValue.replace(',', '.');

        setMyReferralRate(normalizedValue);

        // Обновляем отображение только если значение изменилось
        if (value !== (normalizedValue ? normalizedValue + '%' : '')) {
            input.value = normalizedValue ? normalizedValue + '%' : '';
        }

        // Сохраняем позицию курсора относительно начала ввода (без учёта %)
        const cursorPosition = input.selectionStart;
        const maxCursorPosition = normalizedValue.length;

        // Устанавливаем курсор, избегая позиции после %
        input.setSelectionRange(
            Math.min(cursorPosition, maxCursorPosition),
            Math.min(cursorPosition, maxCursorPosition)
        );
    };

    // Обработчик фокуса: убираем % при фокусе для удобства редактирования
    const handleFocus = (e) => {
        e.target.value = myReferralRate;
    };

    // Обработчик размытия: возвращаем % при потере фокуса
    const handleBlur = (e) => {
        e.target.value = myReferralRate ? myReferralRate + ' %' : '';
    };

    const handleAmountChange = (e) => {
        const input = e.target;
        const value = input.value;

        // Разрешаем цифры, точку и запятую (для дробных чисел)
        const cleanValue = value.replace(/[^0-9.,]/g, '');

        // Заменяем запятую на точку для единообразия
        const normalizedValue = cleanValue.replace(',', '.');

        setTargetAmount(normalizedValue);

        // Обновляем отображение только если значение изменилось
        if (value !== (normalizedValue ? normalizedValue + ' STT' : '')) {
            input.value = normalizedValue ? normalizedValue + ' STT' : '';
        }

        // Сохраняем позицию курсора относительно начала ввода (без учёта %)
        const cursorPosition = input.selectionStart;
        const maxCursorPosition = normalizedValue.length;

        // Устанавливаем курсор, избегая позиции после %
        input.setSelectionRange(
            Math.min(cursorPosition, maxCursorPosition),
            Math.min(cursorPosition, maxCursorPosition)
        );
        setAmountToSend((normalizedValue / (1 - (myReferralRate / 100))).toFixed(6))

    };

    // Обработчик фокуса: убираем % при фокусе для удобства редактирования
    const handleAmountFocus = (e) => {
        e.target.value = targetAmount;
    };

    // Обработчик размытия: возвращаем % при потере фокуса
    const handleAmountBlur = (e) => {
        e.target.value = targetAmount ? targetAmount + ' STT' : '';
    };

    const handleReferralRateChange = () => {
        if (window.ethereum) {
            if (myReferralRate >= 0) {
                setPreloader({display: 'flex'})
                window.ethereum.request({method: "eth_chainId"}).then((result) => {
                    if (parseInt(result) === 42161) {
                        const provider_balance = new ethers.BrowserProvider(window.ethereum)
                        provider_balance.listAccounts().then(async (result) => {
                            const signer = await provider_balance.getSigner()
                            const SttContract = new ethers.Contract(tokenContractAddress, tokenContractAbi, signer)
                            SttContract.balanceOf(props.account).then((res) => {
                                const balance = parseInt(res) / 10**9
                                if (balance < priceOfChange) {
                                    setPreloader({display: 'none'})
                                    setToastText('Insufficient balance')
                                    setToastErrorShow(true)
                                } else {
                                    const marketContract = new ethers.Contract(marketContractAddress, marketContractAbi, signer)
                                    const rate = parseInt(myReferralRate)
                                    SttContract.approve(marketContractAddress, (priceOfChange * 10**9).toString()).then((res) => {
                                        setTimeout(function (){
                                            marketContract.setMarketingRate(rate * 10).then(() => {
                                                setTimeout(() => {
                                                    setPreloader({display: 'none'})
                                                    setToastCompleteShow(true)
                                                }, 100)
                                            }).catch((error) => {
                                                setPreloader({display: 'none'})
                                                setToastText('Insufficient balance')
                                                setToastErrorShow(true)
                                            });
                                        }, 1500)
                                    }).catch((error) => {
                                        setPreloader({display: 'none'})
                                        console.log(error)
                                    });
                                }
                            })

                        })
                    } else {
                        switchToArbitrum()
                    }
                })
            }
        }
    }

    function validateAndConvertToChecksum(address) {
        // Remove '0x' prefix if present
        const cleanAddress = address.replace(/^0x/i, '');

        // Validate length and characters
        if (!/^[0-9a-fA-F]{40}$/.test(cleanAddress)) {
            throw new Error('Invalid Ethereum address format');
        }

        // Convert to lowercase for checksum calculation
        const lowerCaseAddress = cleanAddress.toLowerCase();

        // Get the keccak‑256 hash of the address
        const hash = ethers.keccak256(ethers.toUtf8Bytes(lowerCaseAddress)).replace('0x', '');

        let checksumAddress = '0x';
        for (let i = 0; i < lowerCaseAddress.length; i++) {
            // If the ith digit of the hash is greater than 7, uppercase the ith digit in the address
            if (parseInt(hash[i], 16) > 7) {
                checksumAddress += lowerCaseAddress[i].toUpperCase();
            } else {
                checksumAddress += lowerCaseAddress[i];
            }
        }
        return checksumAddress;
    }

    const handleNetSend = () => {
        if (window.ethereum) {
            if (targetAmount > 1) {
                setPreloader({display: 'flex'})
                window.ethereum.request({method: "eth_chainId"}).then((result) => {
                    if (parseInt(result) === 42161) {
                        const provider_balance = new ethers.BrowserProvider(window.ethereum)
                        provider_balance.listAccounts().then(async (result) => {
                            const signer = await provider_balance.getSigner()
                            const marketContract = new ethers.Contract(marketContractAddress, marketContractAbi, signer)
                            const SttContract = new ethers.Contract(tokenContractAddress, tokenContractAbi, signer)
                            let amount = (amountToSend * Math.pow(10,9)).toString().toLocaleString()
                            SttContract.balanceOf(props.account).then((res) => {
                                const balance = parseInt(res) / 10**9
                                if (balance < amountToSend) {
                                    setPreloader({display: 'none'})
                                    setToastText('Insufficient balance')
                                    setToastErrorShow(true)
                                } else {
                                    SttContract.approve(marketContractAddress, amount.toString()).then((res) => {
                                        setTimeout(function (){
                                            const checksumAddress = validateAndConvertToChecksum(targetErc)
                                            marketContract.paymentFromTheShop(checksumAddress, amount.toString()).then(() => {
                                                setTimeout(() => {
                                                    setPreloader({display: 'none'})
                                                    setToastCompleteShow(true)
                                                    setTargetErc('')
                                                    setTargetAmount(0)
                                                    setShowNetSendModal(false)
                                                }, 100)
                                            }).catch((error) => {
                                                setPreloader({display: 'none'})
                                                console.log(error)
                                            });
                                        }, 1500)
                                    }).catch((error) => {
                                        setPreloader({display: 'none'})
                                        setToastText(error.reason)
                                        setToastErrorShow(true)
                                        console.log(error)
                                    });
                                }
                            })
                        })
                    } else {
                        setPreloader({display: 'none'})
                        switchToArbitrum()
                    }
                })
            }
        }
    }

    useEffect(() => {
        if (props.account) {
            const acc = props.account
            const provider_balance = new ethers.BrowserProvider(window.ethereum)
            const marketContract = new ethers.Contract(marketContractAddress, marketContractAbi, provider_balance)
            marketContract.marketingRate(acc).then((res) => {
                setMyReferralRate((parseInt(res) / 10).toFixed(1))
                console.log(parseInt(res))
            })
            marketContract.marketingRateUpdatePrice().then((res) => {
                setPriceOfChange((parseInt(parseInt(res) / 10 ** 9)))
            })
        }
    }, []);

    return (
        <React.Fragment>
            <div className={"main-block eth-card"} style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: 0}}>
                <div style={{padding: '10px 25px 0'}}>
                    <div className={"main-block__header"}>MY REFERRAL RATE</div>
                    <div className={""}>
                        <div style={{display: "flex", alignItems: 'center', justifyContent: 'space-between'}}>
                        <Form.Control ref={inputRef} type="text" placeholder="0.0%" className={"stt-input w-80"} required min={0}
                                      onChange={(e) => handleRateChange(e)} value={myReferralRate ? myReferralRate + '%' : ''} onFocus={handleFocus}
                                      onBlur={handleBlur}
                                      style={{width: '100%', backgroundColor: "transparent",}}/>
                            <Button className="modal-button" style={{
                                width: 150,
                                height: 40,
                                borderRadius: 10,
                                fontWeight: 600,
                                backgroundColor: "#96fac5",
                                color: "#008279",
                                borderColor: "transparent",
                            }} onClick={() => handleReferralRateChange()}>Update</Button>
                        </div>
                        <div className={"additional-balances"}
                             style={{width: '100%', marginTop: 0, fontSize: 11, color: '#888', fontWeight: 600}}>
                            The update will cost {priceOfChange} STT + 0.00001 ETH gas Fee
                        </div>
                        {/*<p style={{fontSize: 12}}>of each incoming transaction is<br/>*/}
                        {/*    automatically distributed as a bonus across<br/>*/}
                        {/*    the partner network</p>*/}
                    </div>
                </div>
                <div style={{
                    display: 'flex',
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    backgroundColor: '#96fac5',
                    padding: '15px 25px',
                    borderBottomLeftRadius: 25,
                    borderBottomRightRadius: 25
                }}>
                    <div>
                        <p style={{fontSize: 10, marginBottom: 0}}>of each incoming transaction is<br/>
                            automatically distributed as a bonus across<br/>
                            the partner network</p>
                    </div>
                    <Button className="modal-button" style={{
                        width: 150,
                        height: 70,
                        borderRadius: 35,
                        fontWeight: 600,
                        backgroundColor: "rgba(255,255,255,.6)",
                        color: "#008279",
                        borderColor: "transparent",
                    }} onClick={() => setShowNetSendModal(true)}>Network<br/>send</Button>
                </div>
            </div>
            <div className={"preloader"} style={preloader}>
                <Grid
                    height="80"
                    width="80"
                    color="#ffffff"
                    ariaLabel="grid-loading"
                    radius="12.5"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                />
            </div>
            <Toast onClose={() => window.location.reload()} show={toastCompleteShow}
                   onClick={() => setToastCompleteShow(false)} autohide delay={5000} position={"middle-center"}
                   className={"complete-toast"}>
                <Toast.Body>
                    <i className="fa-solid fa-circle-check"
                       style={{fontSize: '6rem', margin: 20, color: '#96fac5'}}></i>
                    <p style={{fontWeight: 600}}>SUCCESS</p>
                    <p className={"complete-toast-text"}>Please, refresh the page</p>
                </Toast.Body>
            </Toast>
            <Toast onClose={() => setToastErrorShow(false)} show={toastErrorShow}
                   onClick={() => setToastErrorShow(false)} autohide delay={5000} position={"middle-center"}
                   className={"complete-toast"}>
                <Toast.Body>
                    <i className="fa-solid fa-circle-xmark"
                       style={{fontSize: '6rem', margin: 20, color: '#ff968f'}}></i>
                    <p className={"toast-err"} style={{fontWeight: 600, color: '#dc3545'}}>ERROR</p>
                    <p className={"complete-toast-text"}>{toastText}</p>
                </Toast.Body>
            </Toast>
            <Modal size="sm" show={showWwModal} onHide={() => setWwModal(false)} aria-labelledby="info-mod-title"
                   className={"pre-form-modal telegram-modal"} centered>
                <Modal.Body>
                    <div className={"stt_modal_header"}>

                    </div>
                    <div className={"help-wrapper telegram-wrapper"} style={{paddingLeft: 0, paddingRight: 0}}>
                        <img src={"/img/lock.png"} alt={''} style={{width: 80, marginTop: 70}}/>
                        <p style={{
                            fontSize: '1.1rem',
                            marginBottom: 20,
                            marginTop: 30,
                            color: '#888888'
                        }}>Authorization</p>
                        <p style={{fontSize: '.8rem', marginTop: 0, fontWeight: 400, marginBottom: 25}}>To use full
                            functionality, login to the<br/>website with the browser of your crypto<br/>wallet</p>
                        <a href={"/login.pdf"} target={"_blank"} rel={"noreferrer"} style={{
                            fontSize: '.8rem',
                            marginTop: 0,
                            fontWeight: 500,
                            display: "block",
                            marginBottom: 45,
                            color: '#47c999'
                        }}>Instructions</a>

                        <Button className="modal-button" onClick={() => setWwModal(false)}>Ok</Button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal size="sm" show={showNetSendModal} onHide={() => setShowNetSendModal(false)} aria-labelledby="info-mod-title" className={"pre-form-modal telegram-modal"} centered >
                <Modal.Body>
                    <div className={"stt_modal_header"}>
                        <div style={{width:50}}></div>
                        <div className={"notification_header"} style={{ color: '#aaa', backgroundColor: 'transparent', fontWeight: 600, paddingTop: 15, fontSize: 22 }}>Network Send</div>
                        <div className={"close_btn"} onClick={() => setShowNetSendModal(false)}>
                            <i className="fa-solid fa-xmark"></i>
                        </div>
                    </div>
                    <div className={"help-wrapper telegram-wrapper"} style={{ padding: 15  }}>
                        <Form.Control type="text" placeholder="ERC-20" className={"stt-send-input w-80"} required min={0.0} onChange={(e) => setTargetErc(e.target.value)} value={targetErc} style={{width: '100%', backgroundColor: "transparent", padding: 10, background: '#eee', borderColor: 'transparent', marginBottom: 30, marginTop: 50}} />

                        <Form.Control type="text" placeholder="0.0 STT" className={"stt-input w-80"} required min={0.0} onChange={handleAmountChange} onFocus={handleAmountFocus} onBlur={handleAmountBlur} value={targetAmount ? targetAmount + ' STT' : ''} style={{width: '100%', backgroundColor: "transparent", padding: 0, textAlign: "center"}} />
                        <p style={{color: '#999', marginBottom: 15, fontWeight:600, marginTop:0,fontSize:12}}>Enter the amount to be received by the recipient</p>
                        <div className={"stt-input w-80"} style={{color: '#008279'}}>{amountToSend} STT</div>
                        <p style={{color: '#999', marginBottom: 15, fontWeight:600,marginTop:0,fontSize:12}}>Total amount to be written off</p>
                        {/*{maxValue > 0 ? <span className={"minimal-helper"} style={{ color: '#888', marginTop: 15 }}>{!props.withoutWallet ? 1 : ''} - {maxValue}</span> : ''}*/}

                        <Button className="modal-button" style={{ display: 'block', margin: '40px auto 15px' }} onClick={handleNetSend}>Send</Button>
                    </div>
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}

export default Marketing